import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function Bonuses() {
  return <section className="bg-cream px-4 py-16" data-id="element-108" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-3xl" data-id="element-109" data-mp="1cm7nc5tu7lbz">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gold text-ink" data-id="element-110" data-mp="1citm50wwti64">
          <GiftIcon className="h-7 w-7" aria-hidden data-id="element-111" data-mp="259v6rhjdg5x1" />
        </div>
        <h2 className="mt-4 text-center font-serif text-[32px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-112" data-mp="259bqs6da7rln">
          5 exclusive bonuses — <em className="text-gold" data-id="element-113" data-mp="1w95euox8ezol">free today</em>
        </h2>
        <p className="mt-3 text-center text-[16px] font-semibold text-muted" data-id="element-114" data-mp="1w7lxsw3r4klr">
          Valued at <span className="text-red-600 line-through" data-id="element-115" data-mp="1r9anyldgia3j">$197</span> — included free with your purchase
        </p>

        <div className="mt-10 space-y-8" data-id="element-116" data-mp="kvl18v0nbrvg">
          {bonuses.map(b => <article key={b.n} className="-mx-4 overflow-hidden bg-white sm:mx-0 sm:rounded-3xl" data-id="element-117" data-mp="ftvpfd5lna6b">
              <div className="flex items-center justify-between bg-ink px-5 py-3" data-id="element-118" data-mp="1euq2wib07i3r">
                <span className="text-[14px] font-extrabold uppercase tracking-wider text-goldsoft" data-id="element-119" data-mp="1jszwwpkzscns">Bonus #{b.n}</span>
                <span className="text-[13px] font-semibold text-white" data-id="element-120" data-mp="15s6znx3b33gz">
                  Value: <span className="text-red-300 line-through" data-id="element-121" data-mp="1ara87rihvrtp">${b.value}</span>{" "}
                  <span className="ml-1 rounded-md bg-cta px-2 py-0.5 font-extrabold text-white" data-id="element-122" data-mp="w3fafwpmqx9r">FREE</span>
                </span>
              </div>
              <img src={b.image} alt={`Bonus ${b.n}: ${b.title}`} className="block w-full bg-white" loading="lazy" data-id="element-123" data-mp="10vgono6cyy2f" />
              <div className="px-5 pb-6 pt-2 sm:px-8" data-id="element-124" data-mp="n0e9eafmfwcy">
                <h3 className="font-serif text-[24px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-125" data-mp="r5443vyjn4wa">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-126" data-mp="d5mcz9xrzfjr">{b.body}</p>
                <p className="mt-4 border-l-4 border-gold pl-4 text-[16px] font-semibold leading-snug text-ink" data-id="element-127" data-mp="i2cpjnadft0f">{b.punch}</p>
              </div>
            </article>)}
        </div>

        <CTAButton className="mt-10" label="Yes! I want my 5 free bonuses" data-id="element-128" data-mp="2f1lh1n4h4rh9" />
      </div>
    </section>;
}